export default __webpack_public_path__ + "static/left-timesqaure-45622e856828fdaae4e3b45bc300ef76.png";